export default __webpack_public_path__ + "static/media/Erectus-10-ban.4df60230.jpg";